import { axiosApi } from "app/configs/axiosConfig";

export const fetchTeamById = async (id) => {
    const response = await axiosApi.get(`/team/${id}`);
    return response.data;
  };